interface IBufferOptions {
  countThreshold?: number;
  timeThreshold?: number;
}

type Callback<T> = (entries: T[]) => void;

class Buffer<T> {
  private buffer: T[] = [];
  private countThreshold: number;
  private timeThreshold: number;
  private callbacks: Callback<T>[] = [];
  private interval?: NodeJS.Timer;

  constructor(options?: IBufferOptions) {
    this.countThreshold = options?.countThreshold || 1;
    this.timeThreshold = options?.timeThreshold || -1;
    this.init();
  }

  push(entry: T) {
    const length = this.buffer.push(entry);

    if (length >= this.countThreshold && !!this.callbacks.length) {
      this.flush();
    }

    return length;
  }

  listen(callback: Callback<T>) {
    this.callbacks.push(callback);

    if (!this.interval && this.timeThreshold > 0) {
      this.interval = setInterval(() => this.flush(), this.timeThreshold);
    }

    return () => {
      const index = this.callbacks.indexOf(callback);
      this.callbacks.splice(index, 1);
    };
  }

  private flush() {
    const entries = this.buffer.splice(0);

    if (!entries.length) {
      return;
    }

    for (let i = 0; i < this.callbacks.length; i++) {
      // Check if callback's been removed during execution
      const callback = this.callbacks?.[i];

      if (callback) {
        callback(entries);
      }
    }
  }

  private init() {
    window.addEventListener('blur', () => {
      this.flush();
    });
  }
}

export default Buffer;
